import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-users-user-change-password-dialog',
  templateUrl: './users-user-change-password-dialog.component.html',
  styleUrls: ['./users-user-change-password-dialog.component.scss']
})
export class UsersUserChangePasswordDialogComponent implements OnInit, OnDestroy {

  error: string;
  updateUserPasswordSubscription: Subscription;
  errorMessage: string;
  basicDataForm = new FormGroup({
    newPassword: new FormControl(null, Validators.required),
    confirmNewPassword: new FormControl(null, Validators.required)
  });

  constructor(public dialogRef: MatDialogRef<UsersUserChangePasswordDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Object,
              private userService: UserService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  public accept() {
    const validation = this.validateForm();
    if (validation === true) {
      this.dialogRef.close({ newPassword: this.basicDataForm.get('newPassword'), confirmNewPassword: this.basicDataForm.get('confirmNewPassword')});
    } else {
      this.errorMessage = validation;
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('newPassword').valid) {
      return 'users-page.new password required';
    } else if (!this.basicDataForm.get('confirmNewPassword').valid) {
      return 'users-page.confirm new password required';
    } else if (!(this.basicDataForm.get('newPassword').value === this.basicDataForm.get('confirmNewPassword').value)) {
      return 'users-page.password mismatch required';
    } else {
      return true;
    }
  }

  ngOnDestroy() {
    if (this.updateUserPasswordSubscription) { this.updateUserPasswordSubscription.unsubscribe(); }
  }
}
